import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import axios from 'axios';

//* HOC's
import withLanguageContext from 'context/consumerHOC/LanguageConsumer';

//* Components
import Clock from './Clock';
import Text from 'components/common/Text';

//* Svg paths
import { svgPaths } from './svgIcons';

const endpoint = '//api.openweathermap.org/data/2.5/weather';
const apiKey = process.env.WEATHER_API_KEY;

//* Style
import WeatherStyle from './style';

const cities = [
	{
		id: '616051',
		city: 'Yerevan',
	},
	{
		id: '616635',
		city: 'Gyumri',
	},
	{
		id: '616752',
		city: 'Dilijan',
	},
	{
		id: '616629',
		city: 'Tsakhkadzor',
	},
	{
		id: '616062',
		city: 'Vagharshapat',
	},
	{
		id: '174884',
		city: 'Jermuk',
	},
	{
		id: '174895',
		city: 'Goris',
	},
	{
		id: '174823',
		city: 'Meghri',
	},
	{
		id: '616627',
		city: 'Ijevan',
	},
	{
		id: '616250',
		city: 'Sevan',
	},
	{
		id: '616530',
		city: 'Vanadzor',
	},
	{
		id: '174875',
		city: 'Kapan',
	},
];

const Weather = ({ colClass, selectedLang }) => {
	//! Router
	const router = useRouter();

	//! State
	const [data, setData] = useState();

	useEffect(() => {
		const fetchData = async () => {
			const response = await axios.get(endpoint, {
				params: {
					appid: apiKey,
					lang: selectedLang,
					id: cities[Math.floor(Math.random() * cities.length)]?.id,
					units: 'metric',
				},
			});
			setData(response.data);
		};

		fetchData();
	}, [selectedLang, router.asPath]);

	return data ? (
		<WeatherStyle className={`weather-block ${colClass || ''}`}>
			<div className='weather-inner-block'>
				<div className='w-top-block'>
					<div className='w-first'>
						<svg
							viewBox='0 0 50 30'
							className='weather-svg'>
							<path d={svgPaths[data.weather[0].icon]} />
						</svg>

						<Text
							text={`${Math.round(data.main.temp)}° C`}
							className={'capitalize p font-ping-medium weather-temp'}
						/>
					</div>

					<Clock />
				</div>

				<Text
					text={`${data.name}: ${data.weather[0].description}`}
					className={'capitalize p font-ping-medium weather-name-description'}
				/>
			</div>
		</WeatherStyle>
	) : null;
};

export default withLanguageContext(Weather, ['selectedLang']);
